<div class="popup-dark-view" (click)="closePopup()">
  <div class="popup-container" id="child">
    <div class="popup-title">{{ input.title }}</div>
    <div class="popup-description">{{ input.description }}</div>
    <div class="popup-submit" (click)="closePopup()">
      {{ input.dismissTitle }}
    </div>
  </div>
</div>
